import { render, staticRenderFns } from "./CreatePasswordChangeTicketResultDialog.vue?vue&type=template&id=15de16a4&scoped=true"
import script from "./CreatePasswordChangeTicketResultDialog.vue?vue&type=script&lang=ts"
export * from "./CreatePasswordChangeTicketResultDialog.vue?vue&type=script&lang=ts"
import style0 from "@/components/issuers/styles/create-password-change-ticket-result-dialog.css?vue&type=style&index=0&id=15de16a4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de16a4",
  null
  
)

/* custom blocks */
import block0 from "@/components/issuers/locales/i18n-create-password-change-ticket-result-dialog.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fissuers%2Fchildren%2FCreatePasswordChangeTicketResultDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports